import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_referral_invite_recommendations';
export const route = 'membership_referral_invite_recommendations/[[...referralParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipreferralreceiverpage" */
'../../components/MembershipReferralReceiverPage')));